
import { api } from "./api";

export const expenseCategoryList = async (addUrl = '') => {
  return await api.get(`/expense?${addUrl}`);
};

export const ExpenseCreate = async (data) => {
  return await api.post('expense/post',data);
};

export const ExpenseDelete = async (id) => {
  return await api.get(`expense/delete/${id}`);
};

export const ExpenseUpdate = async (data) => {
  return await api.post('expense/update',data);
};

export const ExpenseTransactionList = async (addUrl = '') => {
  let url = `/expense/transactions?${addUrl}`
  return await api.get(url);
};

export const ExpenseTransactionCreate = async (data) => {
  return await api.post('expense/transaction/post',data);
};

export const ExpenseTransactionUpdate = async (data) => {
  return await api.post('expense/transaction/update',data);
}; 

export const ExpenseTransactionDelete = async (id) => {
  return await api.get(`expense/transaction/delete/${id}`);
};
